import { render, staticRenderFns } from "./order_hexiao.vue?vue&type=template&id=18c167c0&scoped=true"
import script from "./order_hexiao.vue?vue&type=script&lang=js"
export * from "./order_hexiao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c167c0",
  null
  
)

export default component.exports